"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _lodash = _interopRequireDefault(require("lodash.throttle"));
var _isClient = _interopRequireDefault(require("../isClient"));
var isInViewport = function isInViewport(ref, scrollThreshold) {
  var element = ref && ref.current;
  if (!(0, _isClient["default"])() || !element || element.style.display === 'none') {
    return false;
  }
  var rect = element.getBoundingClientRect();
  return rect.top <= window.innerHeight + scrollThreshold && rect.top + rect.height + scrollThreshold >= 0;
};
var _default = function _default(_ref) {
  var onEnterViewCallback = _ref.onEnterViewCallback,
    onExitViewCallback = _ref.onExitViewCallback,
    _ref$timeThrottle = _ref.timeThrottle,
    timeThrottle = _ref$timeThrottle === void 0 ? 50 : _ref$timeThrottle,
    _ref$scrollThreshold = _ref.scrollThreshold,
    scrollThreshold = _ref$scrollThreshold === void 0 ? 0 : _ref$scrollThreshold,
    _ref$stateVars = _ref.stateVars,
    stateVars = _ref$stateVars === void 0 ? [] : _ref$stateVars,
    ref = _ref.ref;
  var _useState = (0, _react.useState)(isInViewport(ref, scrollThreshold)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isInView = _useState2[0],
    setInViewState = _useState2[1];
  var handleInView = function handleInView() {
    if (!isInView) {
      onEnterViewCallback();
      setInViewState(true);
    }
  };
  var handleNotInView = function handleNotInView() {
    if (isInView) {
      onExitViewCallback && onExitViewCallback();
      setInViewState(false);
    }
  };
  (0, _react.useEffect)(function () {
    var isInClient = (0, _isClient["default"])();
    if (!isInClient) {
      return;
    }
    var handleEvent = (0, _lodash["default"])(function () {
      if (isInViewport(ref, scrollThreshold)) {
        handleInView();
      } else {
        handleNotInView();
      }
    }, timeThrottle);
    window.addEventListener('scroll', handleEvent);
    window.addEventListener('resize', handleEvent);
    return function () {
      window.removeEventListener('scroll', handleEvent);
      window.removeEventListener('resize', handleEvent);
    };
  }, [isInView, scrollThreshold, timeThrottle].concat((0, _toConsumableArray2["default"])(stateVars)));
};
exports["default"] = _default;